import type { Phrases } from './Phrases.d';
import React from 'react';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@hdir/ui/accordion';
import { Ul, Li } from '/react4xp/components/List';
import { sanitizeHtml } from '/react4xp/shared/sanitizeHtml';


export const WhatHappensAccordion = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => (
	<Accordion>
		<AccordionItem>
			<AccordionTrigger headingLevel='h2' className="text-md">{phrases['notificationForm.common.whatHappensAccordion.trigger']}</AccordionTrigger>
			<AccordionContent>
				<Ul className='flex flex-col gap-md ml-xl'>
					<Li className="text-balance">{phrases['notificationForm.common.whatHappensAccordion.content.li1']}</Li>
					<Li className="text-balance" dangerouslySetInnerHTML={{ __html: sanitizeHtml(phrases['notificationForm.common.whatHappensAccordion.content.li2.html']) }}/>
				</Ul>
			</AccordionContent>
		</AccordionItem>
	</Accordion>
);
